module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "chapter-1"
    }
  }, [_c('h1', [_vm._v("Chapter 1")]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "chemicals-inside-you-your-biochemistry-and-influences-from-outside"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Chemicals Inside You (Your Biochemistry) and Influences from Outside")]), _vm._v(" "), _c('p', [_vm._v("Every day you are exposed to thousands of chemical agents and combinations of them. They enter you not only through what you eat and drink, but through what you get on the skin and to a great deal through what you inhale. A normal adult person consumes 12 – 15 kilograms (yes, 26 – 33 pounds) of air every 24 hours. In addition, you must consider the weight of dust in the air. The heaviest dust remains on the floor, but much is whirled up and can remain for quite some time floating in the indoor air and most so where there is much use of carpets.")]), _vm._v(" "), _c('p', [_vm._v("There are few studies of such weight ratios, but from the current literature, most people probably consume about a half gram of dust with billions of respirable indoor particles every day (Lewis et al, 1999).")]), _vm._v(" "), _c('p', [_vm._v("Most of us spend about 90% of our time indoors (See detailed statistics from "), _c('a', {
    attrs: {
      "href": "http://ec.europa.eu/eurostat/documents/3930297/5953614/KS-58-04-998-EN.PDF/c789a2ce-ed5b-4a0c-bcbf-693e699db7d7?version=1.0",
      "target": "_blank"
    }
  }, [_vm._v("Eurostat")]), _vm._v("). Everywhere you are exposed to hazardous chemicals, as reported by WHO Europe in the brochure “Combined or multiple exposure to health stressors in indoor built environments” "), _c('strong', [_vm._v("(")]), _vm._v("80 pages, "), _c('a', {
    attrs: {
      "href": "http://www.euro.who.int/__data/assets/pdf_file/0020/248600/Combined-or-multiple-exposure-to-health-stressors-in-indoor-built-environments.pdf?ua=1",
      "target": "_blank"
    }
  }, [_vm._v("Free text")]), _vm._v(") (Citation): \""), _c('em', [_vm._v("Millions of citizens within the WHO European Region spend approximately 90% of their time indoors: In their homes (2/3 of this time), workplaces, schools and public spaces.")]), _vm._v(" "), _c('em', [_vm._v("Despite undeniable improvements in the quality of indoor environments in the last twenty years, a range of health risks still exists, such as indoor air pollution, injury risks, noise, humidity, mould growth, inadequate indoor temperature, lack of hygiene and sanitation equipment, and crowding.\"")]), _vm._v(" (End of citation – Fig. 3).")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.81496in",
      "height": "2.3622in"
    },
    attrs: {
      "alt": "",
      "src": "media/file1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Picture correction")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Fig. 2. Ill. K. Aas 2013. A Dutch investigation of the weight of consumption including the air in different environments")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("(Nov 1987).")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.83465in",
      "height": "2.3622in"
    },
    attrs: {
      "alt": "",
      "src": "media/file2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Fig. 3. "), _c('a', {
    attrs: {
      "href": "http://www.euro.who.int/__data/assets/pdf_file/0020/248600/Combined-or-multiple-exposure-to-health-stressors-in-indoor-built-environments.pdf?ua=1",
      "target": "_blank"
    }
  }, [_vm._v("WHO Europe brochure")]), _vm._v(" on indoor exposure")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.euro.who.int/__data/assets/pdf_file/0020/248600/Combined-or-multiple-exposure-to-health-stressors-in-indoor-built-environments.pdf?ua=1",
      "target": "_blank"
    }
  }, [_vm._v("(Environmental Chemistry and You sample (2).docx")]), _c('span', {
    staticClass: "underline"
  }, [_vm._v(")")])]), _vm._v(" "), _c('p', [_vm._v("Some significant pollutants such as "), _c('a', {
    attrs: {
      "href": "http://apps.sepa.org.uk/spripa/Pages/SubstanceInformation.aspx?pid=1",
      "target": "_blank"
    }
  }, [_vm._v("ammonia")]), _vm._v(" cause great harm to nature without being harmful to human health, but several other substances may contribute to discomfort, reduced function and diseases. The WHO brochure states that the majority of citizens in Europe are exposed to several hazards in their indoor climates. "), _c('strong', [_vm._v("Three main hazardous groups are pointed out: 1/Chemical mixtures and numerous indoor pollutants in volatile forms (VOC) or in particle or dust phases. 2/Additional chemical, biological and physical stressors such as dampness and mould, allergenic dust and VOC from living organisms. 3/Physical stressors including temperature conditions, UV radiation, radon and noise.")]), _vm._v(" See also chapter 33.")]), _vm._v(" "), _c('p', [_vm._v("Similar messages of concern come from the health authorities in other continents.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.33465in",
      "height": "2.3622in"
    },
    attrs: {
      "alt": "",
      "src": "media/file3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Fig. 4. (Ill. K. Aas 2013): A Dutch investigation of the use of different environments (Noy, 1987)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Accordingly, the indoor air quality is most important. It may vary much from room to room, for different individuals and at different ages. This as well as lifestyle may vary much also between countries. The impact of chemicals entering us depends on our own biochemistry at the given moment.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "chemicals-entering-us-may-be-needed-or-not."
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Chemicals entering us may be needed or not.")]), _vm._v(" "), _c('p', [_c('strong', [_c('em', [_vm._v("They may:")])])]), _vm._v(" "), _c('p', [_vm._v("be used as they are")]), _vm._v(" "), _c('p', [_vm._v("be altered and then used")]), _vm._v(" "), _c('p', [_vm._v("hurt us more or less")]), _vm._v(" "), _c('p', [_vm._v("be neutralised and thrown out")]), _vm._v(" "), _c('p', [_vm._v("be divided into smaller units which may be used or thrown out")]), _vm._v(" "), _c('p', [_vm._v("be transferred to the next generation (through the mother’s womb or breast milk or by changing the genetics ("), _c('em', [_vm._v("epigenetics")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("This means that you always, at any moment depend on interactions between the actual environmental chemistry and the state of your internal chemistry.")]), _vm._v(" "), _c('p', [_vm._v("Children are vulnerable to several indoor hazards as pointed out by WHO’s "), _c('a', {
    attrs: {
      "href": "http://www.who.int/ceh/risks/cehousing/en/",
      "target": "_blank"
    }
  }, [_vm._v("Children, housing and health")]), _vm._v(". It is likely that more research into this matter with time will solve some of the present medical riddles. We need answers to several questions. For instance, why do so many people and particularly women suffer from migraine and why do some diseases such as epilepsy, diabetes, allergies and asthma increase? We also need to understand more about different kinds of cancer, disorders of the brain and nervous system, cardiovascular disorders and overweight (to mention a few out of a lot).")]), _vm._v(" "), _c('p', [_vm._v("To be able to understand the influence from environmental chemistry, we need insight into our biochemistry and where and how the chemicals act. With this kind of insight, you probably will agree to my statement that "), _c('em', [_vm._v("you are marvellous, but probably not 100 per cent perfect!")])])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "tolerated-or-not"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Tolerated or Not?")]), _vm._v(" "), _c('p', [_vm._v("We are continuously exposed to a more or less heavy load of chemicals. Fortunately, most of us tolerate much of this. However, you should realise that your personal biochemistry most probably has some weak features. Unfortunately, everybody should be aware that some of her or his biochemistry may fail when exposed to certain environmental chemicals. Each of us is probably at risk in some way or other without knowing enough about it.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.05118in",
      "height": "2.3622in"
    },
    attrs: {
      "alt": "",
      "src": "media/file4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Fig. 5. (Ill. K. Aas ©): Load and individual risk.")]), _vm._v(" "), _c('p', [_vm._v("The relation between each load of one chemical or chemical combinations and the individual tolerance threshold for the given load is critical. Some of us may become ill even when the load appears minimal (Fig. 5, A) while others get ill only when the individual load is massive (Fig. 5, B).")]), _vm._v(" "), _c('p', [_vm._v("We know that both genetic and environmental factors determine individual tolerance thresholds, but we do not know to what extent we have genes and biochemical mechanisms that are prepared to metabolise all new chemicals. We know that a number of chemicals are toxic to all of us. We also know that a large number of individuals get ill from chemical substances that most of us tolerate and prefer to use.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.85433in",
      "height": "2.3622in"
    },
    attrs: {
      "alt": "",
      "src": "media/file5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Fig. 6. (Ill K. Aas © (1989):")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Individual tolerance thresholds for different loads.")]), _vm._v(" "), _c('p', [_vm._v("Individual defence depends on genes that govern the biochemistry of e.g. hormones, enzymes and immunological capacities. Effects at the moment of any exposure depend on this and how former experiences have influenced the individual resistance.")]), _vm._v(" "), _c('p', [_vm._v("The environmental effect on human health is a global challenge. EU health authorities have recognised this and have initiated a large research project (O’Donnell 2014). Much depends on our individual genes and earlier environmental exposures which may have switched some genes on or off (epigenetics, see chapter 9). A major part of our genes derives from the prehistoric cave-dwelling humankind. Our genetic ancestors survived in the fight for life because they developed vital immunities and experiences which they transferred to their offspring.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.39764in",
      "height": "2.3622in"
    },
    attrs: {
      "alt": "",
      "src": "media/file6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Fig. 7. (Ill. K. Aas ©): Our ancestors, the cave-dwellers.")]), _vm._v(" "), _c('p', [_vm._v("Recent DNA research has shown that in addition to having more than 98 % of the same genes as the chimpanzees, some of us also have up to 4 per cent of genes from Neanderthals as a result of interbreeding around 60.000 years ago (Päabo 2014; Sankararaman et al, 2014). We are here thanks to genes inherited because of the "), _c('strong', [_c('a', {
    attrs: {
      "href": "http://en.wikipedia.org/wiki/Survival_of_the_fittest",
      "target": "_blank"
    }
  }, [_vm._v("“survival of the fittest”")]), _vm._v(".")])]), _vm._v(" "), _c('p', [_vm._v("Our cave-dwelling ancestors also consumed 12–15 kilograms of air daily. Substantial differences between now and then are the chemical contents of the air consumed and that of food and drink, not to speak of cosmetics of modern life.")]), _vm._v(" "), _c('p', [_vm._v("If you want more detailed information in chemistry, you may find much in the AK lectures (aklectures.com)"), _c('strong', [_vm._v(":")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.aklectures.com/subject/general-chemistry",
      "target": "_blank"
    }
  }, [_c('em', [_vm._v("general")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.aklectures.com/subject/general-chemistry",
      "target": "_blank"
    }
  }, [_c('em', [_vm._v("chemistry")])]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://www.aklectures.com/subject/organic-chemistry",
      "target": "_blank"
    }
  }, [_c('em', [_vm._v("organic chemistry")])]), _vm._v(" to be useful.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e8ebb36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch007.vue
// module id = 81
// module chunks = 0